import { defineStore } from 'pinia'
import { avatarList } from '@/api/basic'

export const useAvatarStore = defineStore('avatar', {
    state: () => ({
        avatarList: [], // 头像列表
        loading: false, // 加载状态
        initialized: false // 是否已初始化
    }),

    getters: {
        // 根据头像ID获取头像信息
        getAvatarById: (state) => (id) => {
            return state.avatarList.find(avatar => avatar.id === id)
        },
        
        // 根据头像ID获取头像URL
        getAvatarUrl: (state) => (id) => {
            const avatar = state.avatarList.find(avatar => avatar.id === id)
            return avatar ? avatar.image_url : ''
        },

        // 获取启用状态的头像列表
        enabledAvatarList: (state) => {
            return state.avatarList.filter(avatar => avatar.status === 1)
        },

        // 根据分类获取头像列表
        getAvatarsByCategory: (state) => (category) => {
            return state.avatarList.filter(avatar => 
                avatar.status === 1 && 
                (category === 'all' || avatar.category === category)
            )
        },

        // 获取所有分类
        categories: (state) => {
            const categories = [...new Set(state.avatarList.map(avatar => avatar.category))]
            return categories.filter(Boolean)
        }
    },

    actions: {
        // 初始化头像数据
        async initAvatarData() {
            if (this.initialized && this.avatarList.length > 0) {
                return
            }

            this.loading = true
            try {
                // 获取所有头像数据，pageSize设置为1000
                const res = await avatarList({
                    page: 1,
                    pageSize: 1000,
                    status: 1 // 只获取启用状态的头像
                })

                if (res.code === 0 && res.data.list) {
                    this.avatarList = res.data.list
                    this.initialized = true
                }
            } catch (error) {
                console.error('初始化头像数据失败:', error)
            } finally {
                this.loading = false
            }
        },

        // 添加头像到列表
        addAvatar(avatar) {
            this.avatarList.unshift(avatar)
        },

        // 更新头像信息
        updateAvatar(updatedAvatar) {
            const index = this.avatarList.findIndex(avatar => avatar.id === updatedAvatar.id)
            if (index !== -1) {
                this.avatarList[index] = { ...this.avatarList[index], ...updatedAvatar }
            }
        },

        // 删除头像
        removeAvatar(avatarId) {
            this.avatarList = this.avatarList.filter(avatar => avatar.id !== avatarId)
        },

        // 重新加载头像数据
        async refreshAvatarData() {
            this.initialized = false
            await this.initAvatarData()
        }
    }
}) 